var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _circle3, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalk1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    fill: "#1c1530"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 6,
    width: 24,
    height: 5,
    fill: "#c09840"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 11,
    width: 48,
    height: 5,
    fill: "#c09840"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 16,
    width: 72,
    height: 5,
    fill: "#7060a0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 21,
    width: 104,
    height: 70,
    fill: "#2a1840"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 23,
    width: 100,
    height: 66,
    fill: "#120d20"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 29,
    width: 88,
    height: 54,
    fill: "#0f0c1a"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 29,
    width: 88,
    height: 8,
    fill: "#1c1530"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 33,
    r: 2.5,
    fill: "#c05848"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 33,
    r: 2.5,
    fill: "#c09840"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 33,
    r: 2.5,
    fill: "#5ab4ac"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 43,
    width: 44,
    height: 2.5,
    fill: "#5ab4ac",
    opacity: 0.9
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 50,
    width: 62,
    height: 2.5,
    fill: "#5ab4ac",
    opacity: 0.65
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 57,
    width: 30,
    height: 2.5,
    fill: "#c09840",
    opacity: 0.85
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 64,
    width: 52,
    height: 2.5,
    fill: "#5ab4ac",
    opacity: 0.65
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 71,
    width: 26,
    height: 2.5,
    fill: "#c05848",
    opacity: 0.75
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 91,
    width: 104,
    height: 6,
    fill: "#3a2458"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 97,
    width: 132,
    height: 6,
    fill: "#2d1e48"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 103,
    width: 152,
    height: 6,
    fill: "#221638"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 25,
    width: 5,
    height: 5,
    fill: "#c09840",
    opacity: 0.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 25,
    width: 5,
    height: 5,
    fill: "#c09840",
    opacity: 0.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 82,
    width: 5,
    height: 5,
    fill: "#c09840",
    opacity: 0.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 82,
    width: 5,
    height: 5,
    fill: "#c09840",
    opacity: 0.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 1,
    width: 6,
    height: 6,
    fill: "#c05848",
    opacity: 0.85,
    transform: "rotate(45 80 4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk1);
export default __webpack_public_path__ + "static/media/talk1.cf7272c1355d16e275a0bd1b4da5ffcc.svg";
export { ForwardRef as ReactComponent };